import request from "../../Requests/requests";
import { loadArrayTagsToTask } from "../../store/TagsToTasksStore/TagsToTasksReducer";

export const getTagsToTask = (payload) => {
    return async dispatch => {
        try {
            const response = await request.get('/Task/Tags', { params: {
                TaskId: payload.id,
                UserId: localStorage.getItem('userID')
            }})
            const data = response.data
            .then(response => response.data)
            .then(data => dispatch(loadArrayTagsToTask(data)))
            return data
        } catch (error) {
            return error
        }
    }
}